import React from "react";
import { UseFormReturn } from "react-hook-form";
import { SwitchSettingWithDescription } from "./SwitchSettingWithDescription";

type CompeteWithNonBuyBoxEligibleSellersProps = {
  control: UseFormReturn["control"];
  translate: (_key: string) => string;
};

export const CompeteWithNonBuyBoxEligibleSellers: React.FC<
  CompeteWithNonBuyBoxEligibleSellersProps
> = ({ control, translate }) => {
  return (
    <SwitchSettingWithDescription
      control={control}
      name="competeWithNonBuyEligibleBoxSellers"
      title={translate("competeWithNonBuyBoxEligibleSellers")}
      description={translate("competeWithNonBuyBoxEligibleSellersDescription")}
    />
  );
};
